export const UPDATE_ZAPIER_DATA = "UPDATE_ZAPIER_DATA";
export const DISABLE_LEGACY_ZAPIER = "DISABLE_LEGACY_ZAPIER";
export const SET_LEGACY_ZAPIER = "SET_LEGACY_ZAPIER";
export const SET_NEW_ZAPIER = "SET_NEW_ZAPIER";
export const LEGACY_ZAPIER = 1;
export const NEW_ZAPIER = 2;